export enum IS37PageVariant {
    READ,
    CREATE,
    CLONE,
}
